export default __webpack_public_path__ + "static/media/go-arrow.cbff86d8.svg";